"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EnergyLabel = exports.ENERGY_LABEL_SIZE = exports.ENERGY_LABEL_RATING = exports.ENERGY_LABEL_RANGE = void 0;
var _react = _interopRequireDefault(require("react"));
var _useToggle = _interopRequireDefault(require("react-use/lib/useToggle"));
var _Icon = require("b2b-components/theme/components/Icon");
var _Modal = require("b2b-components/theme/components/Modal");
var _upperCase = require("b2b-components/utils/upperCase");
var _classnames = _interopRequireDefault(require("classnames"));
require("./EnergyLabel.scss");
let ENERGY_LABEL_SIZE = exports.ENERGY_LABEL_SIZE = /*#__PURE__*/function (ENERGY_LABEL_SIZE) {
  ENERGY_LABEL_SIZE["default"] = "default";
  ENERGY_LABEL_SIZE["small"] = "small";
  return ENERGY_LABEL_SIZE;
}({});
let ENERGY_LABEL_RANGE = exports.ENERGY_LABEL_RANGE = /*#__PURE__*/function (ENERGY_LABEL_RANGE) {
  ENERGY_LABEL_RANGE["newRangeAG"] = "newRangeAG";
  ENERGY_LABEL_RANGE["rangeAPPPG"] = "rangeAPPPG";
  ENERGY_LABEL_RANGE["rangeAPPG"] = "rangeAPPG";
  ENERGY_LABEL_RANGE["rangeAPG"] = "rangeAPG";
  ENERGY_LABEL_RANGE["rangeAG"] = "rangeAG";
  return ENERGY_LABEL_RANGE;
}({});
let ENERGY_LABEL_RATING = exports.ENERGY_LABEL_RATING = /*#__PURE__*/function (ENERGY_LABEL_RATING) {
  ENERGY_LABEL_RATING["A+++"] = "A+++";
  ENERGY_LABEL_RATING["A++"] = "A++";
  ENERGY_LABEL_RATING["A+"] = "A+";
  ENERGY_LABEL_RATING["A"] = "A";
  ENERGY_LABEL_RATING["B"] = "B";
  ENERGY_LABEL_RATING["C"] = "C";
  ENERGY_LABEL_RATING["D"] = "D";
  ENERGY_LABEL_RATING["E"] = "E";
  ENERGY_LABEL_RATING["F"] = "F";
  ENERGY_LABEL_RATING["G"] = "G";
  return ENERGY_LABEL_RATING;
}({});
const EnergyLabel = _ref => {
  let {
    className,
    range,
    rating,
    size = ENERGY_LABEL_SIZE.default,
    energyLabelUrl,
    text
  } = _ref;
  const rootClassName = (0, _classnames.default)('cds-EnergyLabel', `cds-EnergyLabel--Rating${rating.replace(/\+/g, 'P')}`, {
    [`cds-EnergyLabel--${(0, _upperCase.upperCaseFirst)(range || '')}`]: range !== ENERGY_LABEL_RANGE.newRangeAG,
    [`cds-EnergyLabel--${(0, _upperCase.upperCaseFirst)(size || '')}`]: size !== ENERGY_LABEL_SIZE.default,
    'cds-EnergyLabel--Eu': range === ENERGY_LABEL_RANGE.newRangeAG,
    'cds-EnergyLabel--WithModal': !!energyLabelUrl
  }, className);
  const [isModalOpen, setIsModalOpen] = (0, _useToggle.default)(false);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: rootClassName,
    onClick: () => setIsModalOpen(true)
  }, range === ENERGY_LABEL_RANGE.newRangeAG && /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    className: "cds-EnergyLabel-Icon",
    name: _Icon.ICON_NAME.rangeEu
  }), rating), energyLabelUrl && isModalOpen && /*#__PURE__*/_react.default.createElement(_Modal.Modal, {
    content: () => /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("img", {
      className: "cds-EnergyLabelModal-Image",
      src: energyLabelUrl,
      alt: text?.energyLabel || 'Energy Label'
    }), /*#__PURE__*/_react.default.createElement(_Modal.ModalButtons, {
      secondary: {
        label: text?.close || 'close',
        onClick: () => setIsModalOpen(false)
      }
    })),
    isOpen: isModalOpen,
    onCloseModal: () => setIsModalOpen(false),
    title: text?.energyLabel || 'Energy Label',
    type: _Modal.MODAL_TYPE.small
  }));
};
exports.EnergyLabel = EnergyLabel;
//# sourceMappingURL=EnergyLabel.js.map